import { render } from "./FormText.vue?vue&type=template&id=38084afa&scoped=true"
import script from "./FormText.ts?vue&type=script&lang=js&external"
export * from "./FormText.ts?vue&type=script&lang=js&external"

import "./FormText.scss?vue&type=style&index=0&id=38084afa&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38084afa"]])

export default __exports__